<template>
  <div id="lineStartupRequestList" class="common_type2">
    <div class="common_tit_wrap">
      <div class="common_page_tit">회선관리: 정지해제</div>
      <div class="common_page_desc">
        저압 모뎀 웹사이트
        <template v-if="userInfoDetail.userRole === 2 || userInfoDetail.userRole === 3">
          |
          <template v-if="userInfoDetail.affiliateCode != null">
            <template v-for="afc in afcList" v-if="afc.codeValue === userInfoDetail.affiliateCode">{{afc.codeName}}</template>
          </template>
          <template v-if="userInfoDetail.officeCode != null">
            <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === userInfoDetail.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
          </template>
        </template>
      </div>
      <div class="common_progress_wrap">
        <div class="common_progress_start on">요청<span style="display: none;">({{countParams.cancel['1']}}건)</span></div>
        <div class="common_progress_middle" @click="movePage('ProgressList')">처리중<span style="display: none;">({{countParams.cancel['2']}}건)</span></div>
        <div class="common_progress_end" @click="movePage('CompleteList')">완료<span style="display: none;">({{countParams.cancel['3']}}건)</span></div>
      </div>
    </div>
    <div class="common_list_notice_wrap">
      <img class="common_list_notice_bg" src="../../assets/common/ic_warning.svg"/>
      <div class="common_list_notice_tit_wrap">
        <div class="common_list_notice_tit">안내</div>
        <div class="common_list_notice_desc">회선관리: 정지해제 메뉴 기능을 처음 이용하시는 분은 반드시 우측의 [매뉴얼 & 담당자]를 확인하시고 이용하여 주시기 바랍니다.</div>
      </div>
      <div class="common_list_notice_manual" @click="openManual('LineStartupRequest')">매뉴얼 & 담당자</div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model="selectSize" @change="search(1)">
<!--            <option value="10">10줄 표시</option>-->
<!--            <option value="20">20줄 표시</option>-->
            <option value="50">50줄 표시</option>
            <option value="100">100줄 표시</option>
            <option value="200">200줄 표시</option>
            <option value="500">500줄 표시</option>
          </select>
        </div>
        <template v-if="mySession.userRole === 2">
          <div class="btn_top btn_green_t" @click="toggleList">모뎀 요청보기({{isOffice ? '등록자' : '본부'}})</div>
          <div class="link fc_primary_blue" @click="downloadFile('/upload/templates/kepco_ams_startup_template.xlsx')">엑셀 등록 템플릿 다운로드</div>
          <input type="file" id="excelFile" @change="readExcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none;"/>
          <label for="excelFile" class="btn_top btn_green">엑셀 일괄 등록</label>
          <div class="btn_top btn_green" @click="showPopup('무선모뎀 검색', 'ModemSearchPopup', {})">회선 정지해제 등록</div>
        </template>
      </div>
      <div class="common_list_top top_row_2">
        <div class="list_filter_group">
          <div class="list_filter_tit">현재상태</div>
          <label class="list_filter_item">
            <input
              type="checkbox"
              :checked="currentStateFilter === 'CRS01'"
              @change="toggleCurrentStateFilter('CRS01')"
            />
            <span>사용</span>
          </label>
          <label class="list_filter_item">
            <input
              type="checkbox"
              :checked="currentStateFilter === 'CRS03'"
              @change="toggleCurrentStateFilter('CRS03')"
            />
            <span>정지</span>
          </label>
        </div>

        <div class="list_filter_group">
          <div class="list_filter_tit">요청가능여부</div>
          <label class="list_filter_item">
            <input
              type="checkbox"
              :checked="canRequestFlagFilter === 1"
              @change="toggleCanRequestFlagFilter(1)"
            />
            <span>가능</span>
          </label>
          <label class="list_filter_item">
            <input
              type="checkbox"
              :checked="canRequestFlagFilter === 0"
              @change="toggleCanRequestFlagFilter(0)"
            />
            <span>불가능</span>
          </label>
        </div>

        <div
          class="btn_filter_reset"
          v-if="currentStateFilter !== null || canRequestFlagFilter !== null"
          @click="resetListFilter"
        >
          필터 초기화
        </div>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>본부</span></div>
          <div><span>이동전화번호</span></div>
          <div><span>등록일</span></div>
          <div><span>처리현황</span></div>
          <div><span>현재상태</span></div>
          <div><span>요청가능여부</span></div>
          <div><span>요청불가사유</span></div>
          <div><span>등록자</span></div>
          <div><span>삭제</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'cs_' + item.csPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" :value="item.csPid" @click.stop="onClickCheckItem(item)"/></span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup('모뎀정보 보기', 'ModemViewPopup', item)">{{item.mobileNum}}</span></div>
            <div>
              <span v-if="item.registerDate != null">{{item.registerDate}}</span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.progressType != null">
                <template v-for="prg in prgList" v-if="prg.codeValue === item.progressType">{{prg.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <template v-if="item.currentState != null">
                <template v-for="crs in crsList" v-if="crs.codeValue === item.currentState">
                  <span :key="'crs_' + crs.codePid" class="btn_status fc_white" :class="item.currentState === 'CRS01' ? 'bc_status_green' : 'bc_status_red'">{{crs.codeName}}</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
            <div>
              <template v-if="item.canRequestFlag != null">
                <template v-for="crf in canRequestFlagList" v-if="crf.codeValue === item.canRequestFlag">
                  <span :key="'crf_' + crf.codeValue" v-if="item.canRequestFlag === 1">가능</span>
                  <span :key="'crf_' + crf.codeValue" v-else class="hover_wrap fc_red">불가능</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
            <div>
              <template v-if="item.canRequestFlag != null">
                <template v-for="crf in canRequestFlagList" v-if="crf.codeValue === item.canRequestFlag">
                  <span :key="'crf_' + crf.codeValue" v-if="item.canRequestFlag !== 1" class="hover_wrap fc_red">
                    <template v-if="item.canRequestFlag === 2 || item.canRequestFlag === 3 || item.canRequestFlag === 4">{{crf.codeName}}</template>
                    <template v-else>알 수 없음</template>
                  </span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup(`회선 정지해제 요청자 정보(${item.mobileNum})`, 'MemberPopup', item)">{{item.userName}}</span></div>
            <div><span class="link fc_primary_blue" @click="deleteSelectedItem(item)">삭제</span></div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <template v-if="mySession.userRole === 1">
          <div class="btn_bottom btn_red_t" @click="deleteSelectedItemList">선택 삭제</div>
        </template>
        <template v-if="mySession.userRole === 2">
          <div class="btn_bottom btn_red_t" @click="deleteSelectedItemList">선택 삭제</div>
          <div class="btn_bottom btn_blue_t" @click="requestComplete">요청완료(선택)</div>
        </template>
        <div class="common_list_page_wrap center_page">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
      </div>
    </div>
    <excel-exporter ref="excel" :filter="excelFilter" :type="'modem'" @downloading="excelDownloadStarted" @fail="excelDownloadFail"/>
    <modal name="viewPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <popup :popup-params="popupParams" @hidePopup="hidePopup" @setSelectedItemList="setSelectedItemList"/>
    </modal>
    <modal name="loadingProgress" classes="loading_progress_wrap" width="300px" height="200px">
      <div>{{progressMsg}}</div>
    </modal>
    <modal name="errorPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <div class="popup_wrap">
        <div class="popup_tit">
          <div>엑셀 일괄 등록 실패 목록</div>
        </div>
        <div class="popup_content">
          <div class="error_list_wrap">
            <div class="error_wrap" v-if="errorList999TotalCount > 0">
              <div class="error_wrap_tit">요청 실패 ({{ errorList999TotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorList999MobileNumText"></div>
            </div>
            <div class="error_wrap" v-if="errorList1TotalCount > 0">
              <div class="error_wrap_tit">데이터 추가 실패 ({{ errorList1TotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorList1MobileNumText"></div>
            </div>
            <div class="error_wrap" v-if="errorList102TotalCount > 0">
              <div class="error_wrap_tit">이동전화번호를 찾을 수 없음 ({{ errorList102TotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorList102MobileNumText"></div>
            </div>
            <div class="error_wrap" v-if="errorListOtherTotalCount > 0">
              <div class="error_wrap_tit">알 수 없는 오류 ({{ errorListOtherTotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorListOtherMobileNumText"></div>
            </div>
          </div>
        </div>
        <div class="popup_btn_wrap">
          <div class="btn_close" @click="hideErrorPopup">닫기</div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import Popup from '../common/Popup.vue'
import ExcelExporter from '../excel/ExcelExporter.vue'
import common from '../../script/common'
import modemStop from '../../script/modemStop'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {VueDatepickerLocal, ExcelExporter, Popup},
  props: ['countParams'],
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      userInfoDetail: JSON.parse(sessionStorage.getItem('userInfoDetail')),
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      rwkList: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      canRequestFlagList: common.canRequestFlagList(),
      // Search
      isOffice: false,
      currentStateFilter: null,
      canRequestFlagFilter: null,
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '50',
      list: [],
      checkAll: false,
      selectedItemList: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      },
      // Popup
      popupParams: {
        title: '',
        component: '',
        data: {}
      },
      // Excel Download
      excelFilter: {
        page: 1,
        size: 100000
      },
      excelDownloading: false,
      // Excel Upload
      progressMsg: '',
      progress: 0,
      totalCount: 0,
      errorList: [],
      errorList999: [],
      errorList1: [],
      errorList102: [],
      errorListOther: [],
      // loading
      vueLoadingOverlay: null
    }
  },
  computed: {
    errorList999MobileNumText () {
      return this.getErrorMobileNumText(this.errorList999)
    },
    errorList1MobileNumText () {
      return this.getErrorMobileNumText(this.errorList1)
    },
    errorList102MobileNumText () {
      return this.getErrorMobileNumText(this.errorList102)
    },
    errorListOtherMobileNumText () {
      return this.getErrorMobileNumText(this.errorListOther)
    },
    errorList999TotalCount () {
      return this.getErrorMobileNumCount(this.errorList999)
    },
    errorList1TotalCount () {
      return this.getErrorMobileNumCount(this.errorList1)
    },
    errorList102TotalCount () {
      return this.getErrorMobileNumCount(this.errorList102)
    },
    errorListOtherTotalCount () {
      return this.getErrorMobileNumCount(this.errorListOther)
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        this.$emit('getCount')
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              this.searchParams = this.$route.params.searchParams
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    getErrorMobileNumText (errorList) {
      if (!Array.isArray(errorList) || errorList.length <= 0) {
        return ''
      }

      const mobileNumList = []

      for (let i = 0; i < errorList.length; i++) {
        const error = errorList[i]

        if (error == null) {
          continue
        }

        if (Array.isArray(error.list)) {
          for (let j = 0; j < error.list.length; j++) {
            if (error.list[j] != null && error.list[j] !== '') {
              mobileNumList.push(String(error.list[j]))
            }
          }
        } else if (error.mobileNum != null && error.mobileNum !== '') {
          mobileNumList.push(String(error.mobileNum))
        }
      }

      return mobileNumList.join(', ')
    },
    getErrorMobileNumCount (errorList) {
      if (!Array.isArray(errorList) || errorList.length <= 0) {
        return 0
      }

      let count = 0

      for (let i = 0; i < errorList.length; i++) {
        const error = errorList[i]

        if (error == null) {
          continue
        }

        if (Array.isArray(error.list)) {
          count += error.list.length
        } else if (error.mobileNum != null && error.mobileNum !== '') {
          count++
        }
      }

      return count
    },
    // Button Action
    movePage (path) {
      this.$router.push(path)
    },
    downloadFile (url) {
      if (url != null && url.length > 0) {
        common.fileDownload(url)
      }
    },
    downloadExcel () {
      if (this.excelDownloading) {
        common.amsAlert('general', '이미 다운로드 처리중입니다.')
        return
      }
      if (confirm('엑셀 다운로드는 데이터 양에 따라 상당한 시간이 소요될 수 있으며 데이터 10만개당 하나의 파일로 다운로드 됩니다.\n또한 브라우저 보안정책에 따라 연속 다운로드 권한을 허용해야합니다.\n정말 다운로드 하시겠습니까?')) {
        this.progressMsg = '다운로드 준비중...'
        this.$modal.show('loadingProgress')
        this.vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        this.$refs.excel.runExport()
        this.excelDownloading = true
      }
    },
    excelDownloadStarted () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    excelDownloadFail () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    // Common
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    // List
    onClickCheckAll () {
      this.selectedItemList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedItemList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedItemList = this.selectedItemList.filter(item => { return item.csPid !== selectedItem.csPid })
      } else {
        this.selectedItemList.push(selectedItem)
      }
      this.checkAll = this.selectedItemList.length === this.list.length
    },
    toggleList () {
      this.isOffice = !this.isOffice
      this.search(1)
    },
    toggleCurrentStateFilter (value) {
      this.currentStateFilter = this.currentStateFilter === value ? null : value
      this.search(1)
    },
    toggleCanRequestFlagFilter (value) {
      this.canRequestFlagFilter = this.canRequestFlagFilter === value ? null : value
      this.search(1)
    },
    resetListFilter () {
      this.currentStateFilter = null
      this.canRequestFlagFilter = null
      this.search(1)
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize),
        isStop: false,
        step: 1,
        currentState: this.currentStateFilter,
        canRequestFlag: this.canRequestFlagFilter
      }

      if (this.mySession.userRole === 2) {
        delete this.filter['sameOffice']
        if (this.isOffice) {
          this.filter.sameOffice = true
        }
      } else if (this.mySession.userRole === 3 || this.mySession.userRole === 4) {
        this.filter.sameOffice = true
      }

      this.updateList()
    },
    updateList () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemStop.getModemStop(this.filter, response => {
        console.log('[회선관리: 정지해제] 요청 목록', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '모뎀 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
        this.selectedItemList = []
      }, error => {
        const status = error && error.response ? error.response.status : null

        if (status >= 500) {
          alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
        } else {
          alert('정보를 불러오던 중 오류가 발생했습니다.')
        }
      })
    },
    showPopup (title, component, data) {
      if (component === 'ModemSearchPopup') {
        const result = common.checkUserRole(this.mySession, 2, 'add')
        if (!result.code) {
          return
        }
      }
      this.popupParams.title = title
      this.popupParams.component = component
      this.popupParams.data = {searchType: 'STOP', type: 'R', data: data}
      this.$modal.show('viewPopup')
    },
    hidePopup (args) {
      this.$modal.hide('viewPopup')
      if (args != null && args.type != null) {
        if (args.type === 'L') {
          this.selectedItemList = []
          this.updateList()
        }
      }
    },
    setSelectedItemList (args) {
      this.$modal.hide('viewPopup')
      if ((this.mySession.subRole & 16) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      if (args != null && args.type != null && args.type === 'AS' && args.data != null && args.data.length > 0) {
        let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        modemStop.modemStop('put', {
          isStop: false,
          numList: args.data
        }, response => {
          console.log('[회선관리: 정지해제] 등록', response)
          vueLoadingOverlay.hide()
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '선택한 모뎀을 등록했습니다.')
            this.updateList()
          } else {
            common.amsAlert('retry', '모뎀을 등록하지 못했습니다.')
          }
        })
      }
    },
    hideErrorPopup () {
      this.$modal.hide('errorPopup')
    },
    readExcel (e) {
      if ((this.mySession.subRole & 16) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      this.progressMsg = '데이터 읽는 중...'
      this.$modal.show('loadingProgress')
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      common.readExcel(e, 'CANCEL')
        .then((result) => {
          console.log('모뎀 엑셀 일괄 등록', result.length)
          this.progressMsg = `데이터 검증 중 (0/${result.length})...`
          let resultCnt = 0
          let numList = []
          for (let i = 0; i < result.length; i++) {
            numList.push(result[i].mobileNum.replace(/\D/g, ''))
            resultCnt++
            this.progressMsg = `데이터 검증 중 (${resultCnt}/${result.length})...`
          }
          let intervalCnt = 0
          let interval = setInterval(() => {
            if (resultCnt === result.length) {
              clearInterval(interval)
              this.progressMsg = `데이터 작성 중 (0/${result.length})...`
              this.startProcessing(numList, vueLoadingOverlay)
            } else if (intervalCnt > 10) {
              clearInterval(interval)
              vueLoadingOverlay.hide()
              common.amsAlert('retry', '엑셀 일괄 등록을 실패했습니다.')
            } else {
              intervalCnt++
            }
          }, 500)
        })
        .catch((error) => {
          this.$modal.hide('loadingProgress')
          vueLoadingOverlay.hide()
          console.error(error)
          common.amsAlert('general', error)
        })
    },
    async startProcessing (result, vueLoadingOverlay) {
      this.totalCount = result.length
      this.progress = 0
      this.errorList = []
      const chunkSize = 1000
      const totalChunks = result.length / chunkSize
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize
        const end = start + chunkSize
        const chunk = result.slice(start, end)
        await this.processChunk(chunk, start, end)
        this.progress += 1000
        this.progressMsg = `데이터 작성 중 (${this.progress}/${result.length})...`
      }
      this.$modal.hide('loadingProgress')
      vueLoadingOverlay.hide()
      if (this.errorList != null && this.errorList.length > 0) {
        this.errorList999 = []
        this.errorList1 = []
        this.errorList102 = []
        this.errorListOther = []
        const errorList = this.errorList
        for (let i = 0; i < errorList.length; i++) {
          if (errorList[i].errorCode === -999) {
            this.errorList999.push(errorList[i])
          } else if (errorList[i].errorCode === -1) {
            this.errorList1.push(errorList[i])
          } else if (errorList[i].errorCode === -102) {
            this.errorList102.push(errorList[i])
          } else {
            this.errorListOther.push(errorList[i])
          }
        }
        common.amsAlert('general', '등록하지 못한 모뎀이 존재합니다.\n에러 팝업을 확인하세요.')
        this.$modal.show('errorPopup')
      } else {
        common.amsAlert('general', '엑셀 일괄 등록을 성공했습니다.')
      }
      this.updateList()
    },
    async processChunk (chunk, start, end) {
      return new Promise(resolve => {
        modemStop.bulkInsertModemStop({
          isStop: false,
          list: chunk
        }, response => {
          // console.log('bulkInsertModemStop', response)
          if (
            response &&
            response.data &&
            response.data.resultCode === 1
          ) {
            if (
              response.data.result &&
              response.data.result.body &&
              response.data.result.body.errorList &&
              response.data.result.body.errorList.length > 0
            ) {
              this.appendErrorList(response.data.result.body.errorList)
            }
          } else {
            this.errorList.push(this.createChunkError(
              response && response.data ? response.data.resultCode : -999,
              start,
              end,
              chunk
            ))
          }
          resolve()
        }, error => {
          console.error(error)
          this.errorList.push(this.createChunkError(-999, start, end, chunk))
          resolve()
        })
      })
    },
    appendErrorList (items) {
      if (!Array.isArray(items) || items.length <= 0) {
        return
      }

      for (let i = 0; i < items.length; i++) {
        this.errorList.push(this.createSlimError(items[i]))
      }
    },
    createSlimError (error) {
      if (error == null) {
        return {
          errorCode: -999,
          mobileNum: ''
        }
      }

      return {
        errorCode: error.errorCode,
        mobileNum: error.mobileNum != null ? String(error.mobileNum) : '',
        registryNum: error.registryNum != null ? String(error.registryNum) : ''
      }
    },
    getMobileNumListFromChunk (chunk) {
      const list = []

      if (!Array.isArray(chunk)) {
        return list
      }

      for (let i = 0; i < chunk.length; i++) {
        const item = chunk[i]

        if (item == null) {
          continue
        }

        if (typeof item === 'string' || typeof item === 'number') {
          list.push(String(item))
        } else if (item.mobileNum != null) {
          list.push(String(item.mobileNum))
        }
      }

      return list
    },
    createChunkError (errorCode, start, end, chunk) {
      const mobileNumList = this.getMobileNumListFromChunk(chunk)

      return {
        errorCode: errorCode,
        start: start,
        end: end,
        count: mobileNumList.length,
        list: mobileNumList
      }
    },
    deleteSelectedItem (item) {
      if ((this.mySession.subRole & 16) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      let result = {}
      if (this.mySession.userRole === 1) {
        result = common.checkUserRole(this.mySession, 1, 'delete')
      } else {
        result = common.checkUserRole(this.mySession, 2, 'delete')
      }
      if (!result.code) {
        return
      }
      // if (this.mySession.userPid !== item.userPid) {
      //   common.amsAlert('general', '자신이 등록한 모뎀만 삭제할 수 있습니다.')
      //   return
      // }
      if (confirm('선택한 모뎀을 삭제하시겠습니까?')) {
        let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        modemStop.modemStop('delete', {
          isStop: false,
          list: [item.csPid]
        }, response => {
          console.log('[회선관리: 정지해제] 삭제', response)
          vueLoadingOverlay.hide()
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '선택한 모뎀을 삭제했습니다.')
            this.updateList()
          } else {
            common.amsAlert('retry', '모뎀을 삭제하지 못했습니다.')
          }
        })
      }
    },
    deleteSelectedItemList () {
      if ((this.mySession.subRole & 16) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      let result = {}
      if (this.mySession.userRole === 1) {
        result = common.checkUserRoleAndList(this.mySession, 1, this.selectedItemList, 'delete', 'CANCEL')
      } else {
        result = common.checkUserRoleAndList(this.mySession, 2, this.selectedItemList, 'delete', 'CANCEL')
      }
      if (!result.code) {
        return
      }
      if (confirm('선택한 모뎀을 삭제하시겠습니까?')) {
        let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        modemStop.modemStop('delete', {
          isStop: false,
          list: result.list
        }, response => {
          console.log('[회선관리: 정지해제] 삭제', response)
          vueLoadingOverlay.hide()
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '선택한 모뎀을 삭제했습니다.')
            this.updateList()
          } else {
            common.amsAlert('retry', '모뎀을 삭제하지 못했습니다.')
          }
        })
      }
    },
    requestComplete () {
      if ((this.mySession.subRole & 16) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRoleAndList(this.mySession, 2, this.selectedItemList, 'reqToAcc', 'CANCEL')
      if (!result.code) {
        return
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemStop.setStep({
        isStop: false,
        step: 2,
        list: result.list
      }, response => {
        console.log('[회선관리: 정지해제] 요청완료', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '선택한 모뎀을 요청완료했습니다.\n요청주신 건은 영업일 기준 익일 처리 예정이오니 참고해주시길 바랍니다.')
          this.updateList()
        } else {
          common.amsAlert('retry', '모뎀을 요청완료하지 못했습니다.')
        }
      })
    },
    openManual (type) {
      common.openManualNewWindow(type)
    }
  }
}
</script>

<style scoped>
#lineStartupRequestList .common_list_middle > .common_list_head > div,
#lineStartupRequestList .common_list_middle > .common_list_body > div > div {
  flex-shrink: 1;
  width: 100%;
}

#lineStartupRequestList .common_list_middle > .common_list_head > div:nth-child(1),
#lineStartupRequestList .common_list_middle > .common_list_body > div > div:nth-child(1) {
  flex-shrink: 0;
  width: 13px;
}

#lineStartupRequestList .common_list_middle > .common_list_head > div:nth-child(3),
#lineStartupRequestList .common_list_middle > .common_list_body > div > div:nth-child(3) {
  flex-shrink: 0;
  width: 85px;
}

#lineStartupRequestList .common_list_middle > .common_list_head > div:nth-child(4),
#lineStartupRequestList .common_list_middle > .common_list_body > div > div:nth-child(4) {
  flex-shrink: 0;
  width: 65px;
}

#lineStartupRequestList .common_list_middle > .common_list_head > div:nth-child(10),
#lineStartupRequestList .common_list_middle > .common_list_body > div > div:nth-child(10) {
  flex-shrink: 0;
  width: 30px;
}

#lineStartupRequestList .common_list_top.top_row_2 {
  align-items: center;
  padding-top: 16px;
}

#lineStartupRequestList .top_row_2 > .list_filter_group {
  display: flex;
  align-items: center;
  gap: 12px;
}

#lineStartupRequestList .top_row_2 > .list_filter_group + .list_filter_group {
  margin-left: 24px;
}

#lineStartupRequestList .list_filter_tit {
  color: #36414F;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

#lineStartupRequestList .list_filter_item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #36414F;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
}

#lineStartupRequestList .list_filter_item > input {
  margin: 0;
}

#lineStartupRequestList .btn_filter_reset {
  height: 32px;
  padding: 0 14px;
  border: 1px solid #E2E8ED;
  border-radius: 4px;
  margin: auto 0 auto auto;
  background: #F8F8F8;
  color: #36414F;
  font-size: 12px;
  font-weight: 700;
  line-height: 30px;
  box-sizing: border-box;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/lineStartup/LineStartupRequestList.vue